import { render, staticRenderFns } from "./marklist.vue?vue&type=template&id=05a99d8a&scoped=true&"
import script from "./marklist.vue?vue&type=script&lang=js&"
export * from "./marklist.vue?vue&type=script&lang=js&"
import style0 from "./marklist.vue?vue&type=style&index=0&id=05a99d8a&prod&lang=css&"
import style1 from "./marklist.vue?vue&type=style&index=1&id=05a99d8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a99d8a",
  null
  
)

export default component.exports